import React, { useMemo } from "react";
import { randomImages } from "../styles.js";

function RandomImage() {
  const random = useMemo(() => Math.floor(Math.random() * randomImages.length), []);
  return (
    <div
      className="relative overflow-hidden h-full"
      style={{
        backgroundImage: `url(${randomImages[random]})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    />
  );
}

export default RandomImage;
